<template>
  <div class="advanced-settings">
    <router-view />
    <FetchingOverlay v-if="GET_SETTINGS_LOADER" />
    <div class="content--main">
      <div class="row">
        <div class="col-4">
          <div class="settings-wrapper">
            <div
              class="setting"
              :class="{ active: selectedSetting.id === setting.id }"
              :ref="
                selectedSetting.id === setting.id ? 'activeSetting' : 'setting'
              "
              @mouseover="hoveredWidget.push(setting.id)"
              @mouseleave="hoveredWidget.splice(1)"
              :style="{
                backgroundColor: hoveredWidget.includes(setting.id)
                  ? secondary
                  : '#fafafa'
              }"
              v-for="setting in settings"
              :key="setting.id"
              @click="handleSettingClick(setting)"
            >
              <p>{{ setting.label }}</p>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="settings-table--wrapper">
            <div class="table-controls">
              <h4>{{ selectedSetting.label }}</h4>
              <ActionButton
                v-if="
                  selectedSetting.id === 0 ||
                    selectedSetting.id === 1 ||
                    selectedSetting.id === 2
                "
                :theme="{ primary, secondary, event, danger }"
                :label="selectedSetting.buttonLabel"
                style="display: inline-block; width: auto; margin-top: 0;"
                @customEvent="() => handleAddClick(selectedSetting.id)"
              />
              <ActionButton
                v-else-if="selectedSetting.id === 7"
                label="Save"
                style="width: auto; margin-left: auto; margin-top: 0;"
                :disabled="disabledSaved"
                :theme="{ primary, secondary, danger, event }"
                @customEvent="handleSaveSubmit(selectedSetting.slug)"
              />
              <ActionButton
                v-else
                label="Save"
                style="width: auto; margin-left: auto; margin-top: 0;"
                :disabled="GET_SETTINGS_LOADER"
                :theme="{ primary, secondary, danger, event }"
                @customEvent="handleSaveSubmit(selectedSetting.slug)"
              />
            </div>
            <div v-if="selectedSetting.id === 0" key="dt-notif">
              <Datatable
                :headers="notifHeaders"
                v-if="emailNotif && emailNotif.length"
              >
                <tr v-for="notif in emailNotif" :key="notif.id">
                  <td>{{ notif.email }}</td>
                  <td>
                    <span
                      :class="[
                        notif.status === 0 ? 'text-danger' : 'text-success'
                      ]"
                    >
                      {{ notif.status === 0 ? "Inactive" : "Active" }}
                    </span>
                  </td>
                  <td class="text-right table__actions-wrapper">
                    <ActionButton
                      label=""
                      style="margin-right: 15px; margin-top: 0;"
                      @customEvent="handleEditClick(notif)"
                    >
                      <img
                        src="~@/assets/media/icons/create-light.svg"
                        alt="edit icon"
                      />
                    </ActionButton>
                    <ActionButton
                      label=""
                      class="btn-danger"
                      style="margin-top: 0; margin-right: 0;"
                      @customEvent="handleDeleteNotif(notif)"
                    >
                      &mdash;
                    </ActionButton>
                  </td>
                </tr>
              </Datatable>

              <template v-else>
                <div class="small">
                  No Emails found.
                </div>
              </template>
            </div>
            <div v-if="selectedSetting.id === 1" key="dt-domain">
              <Datatable :headers="domainHeaders">
                <tr v-for="domain in domains" :key="domain.id">
                  <td>{{ domain.domain }}</td>
                  <td>{{ domain.createdBy }}</td>
                  <td>
                    <span
                      :class="[
                        domain.status === 0 ? 'text-danger' : 'text-success'
                      ]"
                    >
                      {{ domain.status === 0 ? "Inactive" : "Active" }}
                    </span>
                  </td>
                  <td class="text-right table__actions-wrapper">
                    <ActionButton
                      label=""
                      style="margin-right: 15px; margin-top: 0;"
                    >
                      <img
                        src="~@/assets/media/icons/create-light.svg"
                        alt="edit icon"
                      />
                    </ActionButton>
                    <ActionButton
                      label=""
                      class="btn-danger"
                      style="margin-top: 0; margin-right: 0;"
                    >
                      &mdash;
                    </ActionButton>
                  </td>
                </tr>
              </Datatable>
            </div>
            <div v-if="selectedSetting.id === 2" key="dt-manager">
              <Datatable :headers="managerHeaders">
                <tr v-for="manager in managers" :key="manager.id">
                  <td>{{ manager.email }}</td>
                  <td>
                    <span
                      :class="[
                        manager.status === 0 ? 'text-danger' : 'text-success'
                      ]"
                    >
                      {{ manager.status === 0 ? "Inactive" : "Active" }}
                    </span>
                  </td>
                  <td class="text-right table__actions-wrapper">
                    <ActionButton
                      label=""
                      style="margin-right: 15px; margin-top: 0;"
                    >
                      <img
                        src="~@/assets/media/icons/create-light.svg"
                        alt="edit icon"
                      />
                    </ActionButton>
                    <ActionButton
                      label=""
                      class="btn-danger"
                      style="margin-top: 0; margin-right: 0;"
                    >
                      &mdash;
                    </ActionButton>
                  </td>
                </tr>
              </Datatable>
            </div>
            <div v-if="selectedSetting.id === 3" key="registration-settings">
              <div class="form-group row">
                <div class="col-4">
                  <label>{{ isSocialMain[0].label }}</label>
                </div>
                <div class="col-8">
                  <Toggler
                    @toggle="
                      isSocialMain[0].value.status = !isSocialMain[0].value
                        .status
                    "
                    :value="isSocialMain[0].value.status"
                  />
                </div>
              </div>
              <div
                class="social__group sub-group"
                v-if="isSocialMain[0].value.status"
              >
                <div
                  class="form-group row"
                  v-for="(group, i) in isSocialGroup"
                  :key="i"
                >
                  <div class="col-4">
                    <label>{{ group.label }}</label>
                  </div>
                  <div class="col-8">
                    <Toggler
                      @toggle="group.value.status = !group.value.status"
                      :value="group.value.status"
                    />
                    <input
                      v-if="group.value.status"
                      type="text"
                      class="form-control mt-10"
                      placeholder="App ID"
                      v-model="group.value.appId"
                    />
                    <input
                      v-if="group.value.status"
                      type="text"
                      class="form-control mt-10"
                      placeholder="Secret"
                      v-model="group.value.secret"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectedSetting.id === 4" key="logo-settings">
              <div class="form-group row">
                <div class="col-6">
                  <label>{{ isDefaultLogo[0].label }}</label>
                </div>
                <div class="col-6">
                  <Toggler
                    :value="isDefaultLogo[0].value.status"
                    @toggle="defaultLogoStatus = !defaultLogoStatus"
                  />
                </div>
              </div>
              <div
                class="form-group w-100 upload-wrapper"
                v-if="!defaultLogoStatus"
              >
                <label for="featuredImage">Change logo</label>
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <div class="col-9">
                        <input
                          type="text"
                          name="featuredImage"
                          v-model="isDefaultLogoSub[0].value.image"
                          class="form-control"
                          disabled
                        />
                      </div>
                      <div class="col-3">
                        <ActionButton
                          :theme="{ primary, secondary, danger, event }"
                          @customEvent="showModalGallery = true"
                          label="Media Gallery"
                          style="width: auto; margin-top: 0; margin-left: auto;"
                        />
                      </div>
                      <div class="col-12">
                        <p class="w-100 small pt-5">
                          Recommended image size 170x40 pixels in jpeg or png
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectedSetting.id === 5" key="user-settings">
              <div class="form-group row">
                <div class="col-6">
                  <label>Report an Issue</label>
                </div>
                <div class="col-6">
                  <Toggler
                    :value="isSupportMain[0].value.status"
                    @toggle="
                      isSupportMain[0].value.status = !isSupportMain[0].value
                        .status
                    "
                  />
                </div>
              </div>
              <div class="sub-group" v-if="isSupportMain[0].value.status">
                <div
                  class="form-group row"
                  v-for="(supportItem, i) in isSupportGroup"
                  :key="i"
                >
                  <div class="col-6">
                    <label>{{ supportItem.label }}</label>
                  </div>
                  <div class="col-6">
                    <Toggler
                      :value="supportItem.value.status"
                      @toggle="
                        supportItem.value.status = !supportItem.value.status
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="form-group row bordered-top pt-10">
                <div class="col">
                  <label>{{ isWelcomeMain[0].label }}</label>
                  <textarea
                    class="form-control"
                    v-model="isWelcomeMain[0].value.message"
                    placeholder="Hello..."
                  ></textarea>
                </div>
              </div>
              <div class="form-group row bordered-top pt-10">
                <div class="col">
                  <label>{{ isFeedbackMain[0].label }}</label>
                </div>
                <div class="col">
                  <Toggler
                    :value="isFeedbackMain[0].value.status"
                    @toggle="
                      isFeedbackMain[0].value.status = !isFeedbackMain[0].value
                        .status
                    "
                  />
                </div>
              </div>
            </div>
            <div v-if="selectedSetting.id === 6" key="concierge-settings">
              <div class="form-group row">
                <div class="col-6">
                  <label>{{ isCompaniesMain[0].label }}</label>
                </div>
                <div class="col-6">
                  <Toggler
                    :value="isCompaniesMain[0].value.status"
                    @toggle="
                      isCompaniesMain[0].value.status = !isCompaniesMain[0]
                        .value.status
                    "
                  />
                </div>
              </div>
              <div class="sub-group" v-if="isCompaniesMain[0].value.status">
                <div
                  class="form-group row"
                  v-for="(group, i) in isCompaniesGroup"
                  :key="i"
                >
                  <div class="col-6">
                    <label>{{ group.label }}</label>
                  </div>
                  <div class="col-6">
                    <Toggler
                      :value="group.value.status"
                      @toggle="group.value.status = !group.value.status"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group row bordered-top pt-10">
                <div class="col-6">
                  <label>{{ isSmsMain[0].label }}</label>
                </div>
                <div class="col-6">
                  <Toggler
                    :value="isSmsMain[0].value.status"
                    @toggle="
                      isSmsMain[0].value.status = !isSmsMain[0].value.status
                    "
                  />
                </div>
              </div>
              <div class="form-group row bordered-top pt-10">
                <div class="col-6">
                  <label>{{ isLeadsMain[0].label }}</label>
                </div>
                <div class="col-6">
                  <Toggler
                    :value="isLeadsMain[0].value.status"
                    @toggle="
                      isLeadsMain[0].value.status = !isLeadsMain[0].value.status
                    "
                  />
                </div>
              </div>
              <div class="form-group row bordered-top pt-10">
                <div class="col-6">
                  <label>{{ isLogsMain[0].label }}</label>
                </div>
                <div class="col-6">
                  <Toggler
                    :value="isLogsMain[0].value.status"
                    @toggle="
                      isLogsMain[0].value.status = !isLogsMain[0].value.status
                    "
                  />
                </div>
              </div>
            </div>
            <div v-if="selectedSetting.id === 7" key="concierge-settings">
              <div
                class="form-group row payment-options"
                v-for="(payment, i) in isPaymentOptionMain"
                :key="i"
              >
                <div class="col-6">
                  <label>{{ payment.label }}</label>
                </div>
                <div class="col-6 d-flex justify-content-end">
                  <Toggler
                    :value="payment.value.status"
                    :withStatus="false"
                    @toggle="payment.value.status = !payment.value.status"
                  />
                </div>
                <div
                  class="method-holder col-12"
                  v-if="
                    paymentBasics.includes(payment.label) &&
                      payment.value.status
                  "
                >
                  <span>
                    Add information to show customers if they choose
                    {{ payment.label }}.
                  </span>
                  <div class="editor-holder">
                    <vue-editor
                      v-model="payment.value.description"
                      placeholder="Enter description"
                      useCustomImageHandler
                      @image-added="handleImageAdded"
                      @image-removed="handleImageRemoved"
                      :editorToolbar="[
                        ['bold', 'italic', 'underline'],
                        [
                          { align: '' },
                          { align: 'center' },
                          { align: 'right' },
                          { align: 'justify' }
                        ],
                        ['link', 'image']
                      ]"
                      ref="vueEditor"
                      class="custom-editor"
                    />
                  </div>
                </div>
                <div
                  class="method-holder col-12"
                  v-if="i == 1 && payment.value.status"
                >
                  <div class="portal-holder">
                    <span>
                      You’re currently in
                      <span class="text-upper">
                        {{
                          payment.value.data[0].status
                            ? stripeLabel[0]
                            : stripeLabel[1]
                        }}
                      </span>
                      mode. Toggle to switch into
                      <span class="text-upper">
                        {{
                          payment.value.data[0].status
                            ? stripeLabel[1]
                            : stripeLabel[0]
                        }}.
                      </span>
                    </span>
                    <TogglerV2
                      :value="payment.value.data[1].status"
                      :label="stripeLabel"
                      @toggle="
                        payment.value.data[1].status =
                          payment.value.data[0].status;
                        payment.value.data[0].status = !payment.value.data[0]
                          .status;
                      "
                      class="mb-2"
                    />
                    <span>
                      Please make sure to input
                      <span class="text-upper">
                        {{
                          payment.value.data[0].status
                            ? stripeLabel[0]
                            : stripeLabel[1]
                        }}
                      </span>
                      API keys.
                    </span>
                  </div>
                  <div
                    class="form-group mb-0"
                    v-for="(dataOptions, j) in payment.value.data"
                    :key="j"
                  >
                    <template v-if="dataOptions.status">
                      <div
                        v-for="(dataOptionsVal, k) in dataOptions.value"
                        :key="k"
                      >
                        <label>
                          {{ labelTrimmer(dataOptionsVal.label) }}
                          Key
                        </label>
                        <div class="row align-items-center mb-2">
                          <div class="col-12">
                            <input
                              type="text"
                              class="form-control"
                              v-model="dataOptionsVal.value"
                              :placeholder="
                                `${labelTrimmer(dataOptionsVal.label)}Key`
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div
                  class="method-holder col-12"
                  v-if="i == 2 && payment.value.status"
                >
                  <div class="portal-holder">
                    <span>
                      You’re currently in
                      <span class="text-upper">
                        {{
                          payment.value.data[0].status
                            ? paypalLabel[0]
                            : paypalLabel[1]
                        }}
                      </span>
                      mode. Toggle to switch into
                      <span class="text-upper">
                        {{
                          payment.value.data[0].status
                            ? paypalLabel[1]
                            : paypalLabel[0]
                        }}.
                      </span>
                    </span>
                    <TogglerV2
                      :value="payment.value.data[1].status"
                      :label="paypalLabel"
                      @toggle="
                        payment.value.data[1].status =
                          payment.value.data[0].status;
                        payment.value.data[0].status = !payment.value.data[0]
                          .status;
                      "
                      class="mb-2"
                    />
                    <span>
                      Please make sure to input
                      <span class="text-upper">
                        {{
                          payment.value.data[0].status
                            ? paypalLabel[0]
                            : paypalLabel[1]
                        }}
                      </span>
                      API Keys.
                    </span>
                  </div>
                  <div
                    class="form-group mb-0"
                    v-for="(dataOptions, j) in payment.value.data"
                    :key="j"
                  >
                    <template v-if="dataOptions.status">
                      <label>{{ dataOptions.label }} Key</label>
                      <div class="row align-items-center">
                        <div class="col-12">
                          <input
                            type="text"
                            class="form-control"
                            v-model="dataOptions.value"
                            placeholder="API Key"
                          />
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectedSetting.id === 8" key="invoice-settings">
              <div class="form-group">
                <label for="">Address: </label>
                <vue-editor
                  v-model="selectedSetting.data[0].value.address"
                  useCustomImageHandler
                  @image-added="handleImageAdded"
                  @image-removed="handleImageRemoved"
                  ref="vueEditor"
                />
              </div>

              <div class="form-group">
                <label>Instructions: </label>
                <vue-editor
                  v-model="selectedSetting.data[1].value.instructions"
                  useCustomImageHandler
                  @image-added="handleImageAdded"
                  @image-removed="handleImageRemoved"
                  ref="vueEditor"
                />
              </div>
            </div>
            <div v-if="selectedSetting.id === 10" key="color-settings">
              <div class="row">
                <div
                  class="col-md-3"
                  v-for="scheme in schemes"
                  :key="scheme.id"
                  @click="handleChooseTheme(scheme)"
                >
                  <div
                    :class="{ selected: selectedScheme.id === scheme.id }"
                    class="scheme-wrapper"
                  >
                    <div
                      class="circle -outer"
                      :style="{ 'background-color': scheme.secondary }"
                    >
                      <div
                        class="circle -inner"
                        :style="{ 'background-color': scheme.primary }"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MediaGalleryModal
      v-if="showModalGallery"
      @response="handleResponse"
      @close="handleCloseMedia"
      scheme="small"
    />
    <AwayMessage
      v-if="showAwayMessage"
      @close="handleClose"
      @proceed="handleProceedSelect"
    />
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import Datatable from "@/components/Datatable";
import Toggler from "@/components/Toggler";
import TogglerV2 from "@/components/TogglerV2";
import _ from "lodash";
import MediaGalleryModal from "@/components/media-gallery/MediaGalleryModal";
import FetchingOverlay from "@/components/FetchingOverlay";
import { mapState, mapGetters, mapActions } from "vuex";
import editor from "@/helpers/editor";
import AwayMessage from "../components/AwayMessage";

export default {
  name: "AdminSettings",
  components: {
    ActionButton,
    Datatable,
    Toggler,
    TogglerV2,
    MediaGalleryModal,
    FetchingOverlay,
    AwayMessage
  },
  mixins: [editor],
  data: () => ({
    settings: [
      {
        id: 7,
        label: "Payment Options",
        slug: "payment-options-setting"
      },
      {
        id: 8,
        label: "Invoice Details",
        slug: "invoice-details-setting",
        data: [
          {
            key: "invoice.main",
            label: "Invoice Address",
            value: {
              address: ""
            }
          },
          {
            key: "invoice.main",
            label: "Payment Instructions",
            value: {
              instructions: ""
            }
          }
        ]
      },
      {
        id: 0,
        label: "Notification",
        buttonLabel: "Add Email"
      },
      // { // Will be used later hide for now
      //   id: 1,
      //   label: "Whitelisted Domain",
      //   buttonLabel: "Add Domain"
      // },
      // { // Will be used later hide for now
      //   id: 2,
      //   label: "Whitelisted Staff",
      //   buttonLabel: "Add Staff"
      // },
      // { // Will be used later hide for now
      //   id: 3,
      //   label: "User Registration/Login",
      //   slug: "user-registration-setting"
      // },
      {
        id: 5,
        label: "User Dashboard",
        slug: "user-dashboard-setting"
      },
      {
        id: 4,
        label: "Logo",
        slug: "logo-setting"
      },
      // { // Will be used later hide for now
      //   id: 6,
      //   label: "Concierge Dashboard",
      //   slug: "concierge-dashboard-setting"
      // },
      {
        id: 10,
        label: "Color Theme",
        slug: "color-setting"
      }
    ],
    selectedSetting: {},
    notifHeaders: [
      {
        id: 0,
        label: "Email"
      },
      {
        id: 1,
        label: "Status"
      },
      {
        id: 2,
        label: "Action"
      }
    ],
    notifications: [
      {
        id: 0,
        email: "owtee@august99.com",
        status: 0
      },
      {
        id: 1,
        email: "carl.agliam@august99.com",
        status: 1
      },
      {
        id: 2,
        email: "rafael.desuyo@august99.com",
        status: 1
      },
      {
        id: 3,
        email: "klinton.ballecer@august99.com",
        status: 0
      }
    ],
    domainHeaders: [
      {
        id: 0,
        label: "Domain"
      },
      {
        id: 1,
        label: "Created By"
      },
      {
        id: 2,
        label: "Status"
      },
      {
        id: 3,
        label: "Action"
      }
    ],
    domains: [
      {
        id: 0,
        domain: "www.facebook.com",
        createdBy: "Loft Admin",
        status: 0
      },
      {
        id: 1,
        domain: "www.twitter.com",
        createdBy: "Loft Admin",
        status: 1
      },
      {
        id: 2,
        domain: "www.instagram.com",
        createdBy: "Loft Admin",
        status: 0
      },
      {
        id: 3,
        domain: "www.youtube.com",
        createdBy: "Loft Admin",
        status: 0
      }
    ],
    managerHeaders: [
      {
        id: 0,
        label: "Email"
      },
      {
        id: 1,
        label: "Status"
      },
      {
        id: 2,
        label: "Action"
      }
    ],
    managers: [
      {
        id: 0,
        email: "lordwill@august99.com",
        status: 0
      },
      {
        id: 1,
        email: "cinderella@august99.com",
        status: 1
      },
      {
        id: 2,
        email: "benedict@august99.com",
        status: 1
      },
      {
        id: 3,
        email: "sam@august99.com",
        status: 0
      }
    ],
    isSocialMain: [
      {
        key: "sociallogin.main",
        label: "Social Login",
        value: {
          status: false
        }
      }
    ],
    isSocialGroup: [
      {
        key: "sociallogin.sub",
        label: "Facebook",
        value: {
          status: false,
          appId: null,
          secret: null
        }
      },
      {
        key: "sociallogin.sub",
        label: "Google",
        value: {
          status: false,
          appId: null,
          secret: null
        }
      },
      {
        key: "sociallogin.sub",
        label: "LinkedIn",
        value: {
          status: false,
          appId: null,
          secret: null
        }
      }
    ],
    isDefaultLogo: [
      {
        key: "defaultlogo.main",
        label: "Use default QSpace logo",
        value: {
          status: true
        }
      }
    ],
    isDefaultLogoSub: [
      {
        key: "defaultlogo.sub",
        label: "Change logo",
        value: {
          image: null
        }
      }
    ],
    isSupportMain: [
      {
        key: "support.main",
        label: "Report an Issue",
        value: {
          status: true
        }
      }
    ],
    isSupportGroup: [
      {
        key: "support.sub",
        label: "Cleanliness",
        value: {
          status: false
        }
      },
      {
        key: "support.sub",
        label: "Equipment",
        value: {
          status: false
        }
      },
      {
        key: "support.sub",
        label: "Furniture",
        value: {
          status: false
        }
      },
      {
        key: "support.sub",
        label: "Lighting",
        value: {
          status: false
        }
      },
      {
        key: "support.sub",
        label: "Noise",
        value: {
          status: false
        }
      },
      {
        key: "support.sub",
        label: "Printer",
        value: {
          status: false
        }
      },
      {
        key: "support.sub",
        label: "Temperature",
        value: {
          status: false
        }
      },
      {
        key: "support.sub",
        label: "WiFi",
        value: {
          status: false
        }
      }
    ],
    isWelcomeMain: [
      {
        key: "support.welcome",
        label: "Welcome message",
        value: {
          message: null
        }
      }
    ],
    isFeedbackMain: [
      {
        key: "support.feedback",
        label: "Feedback",
        value: {
          status: false
        }
      }
    ],
    isCompaniesMain: [
      {
        key: "concierge.main",
        label: "Companies",
        value: {
          status: true
        }
      }
    ],
    isCompaniesGroup: [
      {
        key: "concierge.sub",
        label: "Private Company",
        value: {
          status: false
        }
      },
      {
        key: "concierge.sub",
        label: "Virtual Company",
        value: {
          status: false
        }
      }
    ],
    isSmsMain: [
      {
        key: "concierge.sms",
        label: "SMS",
        value: {
          status: false
        }
      }
    ],
    isLeadsMain: [
      {
        key: "concierge.leads",
        label: "Leads Management",
        value: {
          status: false
        }
      }
    ],
    isLogsMain: [
      {
        key: "concierge.logs",
        label: "Activity",
        value: {
          status: false
        }
      }
    ],
    isPaymentMain: [
      {
        key: "payment.main",
        label: "Cash",
        value: {
          status: true
        }
      },
      {
        key: "payment.main",
        label: "Stripe",
        value: {
          status: false
        }
      },
      {
        key: "payment.main",
        label: "Paypal",
        value: {
          status: false,
          data: {
            key: null,
            label: null
          }
        }
      },
      {
        key: "payment.main",
        label: "Bank Transfer",
        value: {
          status: false
        }
      },
      {
        key: "payment.main",
        label: "PayMaya",
        value: {
          status: false
        }
      },
      {
        key: "payment.main",
        label: "Cheque",
        value: {
          status: false
        }
      }
    ],
    isPaymentOptionMain: [
      {
        key: "paymentoption.main",
        label: "Cash",
        value: {
          status: true,
          description: "Please provide your cash payment upon arrival."
        }
      },
      {
        key: "paymentoption.main",
        label: "Stripe",
        value: {
          status: false,
          data: [
            {
              value: [
                {
                  value: null,
                  label: "Publishable ID"
                },
                {
                  value: null,
                  label: "Secret ID"
                }
              ],
              label: "production",
              status: true
            },
            {
              value: [
                {
                  value: null,
                  label: "Publishable ID"
                },
                {
                  value: null,
                  label: "Secret ID"
                }
              ],
              label: "sandbox",
              status: false
            }
          ]
        }
      },
      {
        key: "paymentoption.main",
        label: "Paypal",
        value: {
          status: false,
          data: [
            {
              value: null,
              label: "Production",
              status: true
            },
            {
              value: null,
              label: "Sandbox",
              status: false
            }
          ]
        }
      },
      {
        key: "paymentoption.main",
        label: "Bank Transfer",
        value: {
          status: false,
          description: ""
        }
      },
      {
        key: "paymentoption.main",
        label: "PayMaya",
        value: {
          status: false,
          description: ""
        }
      },
      {
        key: "paymentoption.main",
        label: "Cheque",
        value: {
          status: false,
          description: ""
        }
      }
    ],
    isPaypalMain: [
      {
        key: "paypal.main",
        label: "Production Key",
        value: {
          key: null,
          status: true
        }
      },
      {
        key: "paypal.main",
        label: "Testing Key",
        value: {
          key: null,
          status: false
        }
      }
    ],
    url: null,
    isSandboxEnabled: false,
    isProductionEnabled: true,
    fileName: null,
    schemes: [
      {
        id: 0,
        primary: "#51B67E",
        secondary: "#E1FAF4",
        event: "#2A774C",
        danger: "#dc3545"
      },
      {
        id: 1,
        primary: "#EF6637",
        secondary: "#FDEFDB",
        event: "#F24408",
        danger: "#dc3545"
      },
      {
        id: 2,
        primary: "#0099F2",
        secondary: "#E8F4FA",
        event: "#0077BC",
        danger: "#dc3545"
      }
    ],
    style: {},
    selectedScheme: {},
    selectedLogo: {},
    async toastrInit(result) {
      if (result.status == 200) {
        await this.$toastr.success("Your changes are saved", "Success");
      }
    },
    media: {},
    showModalGallery: false,
    hoveredWidget: [],
    defaultLogoStatus: true,
    stripeLabel: ["Live", "Test"],
    paypalLabel: ["Live", "Sandbox"],
    disabledSaved: true,
    checkPaymentOption: [],
    showAwayMessage: false,
    lastSettingClick: {},
    paymentOptionInitial: {
      status: false,
      data: {}
    },
    dataRenderer: {},
    paymentBasics: ["Cash", "Bank Transfer", "PayMaya", "Cheque"]
  }),
  watch: {
    isPaymentOptionMain: {
      handler(val) {
        let dataCompare = [];
        let firstLevelStatus = [];
        this.SET_PAYMENT_METHOD(
          JSON.parse(JSON.stringify(this.GET_PAYMENT_METHOD))
        );
        val.map(e => {
          dataCompare.push(e.value.status);
          firstLevelStatus.push(e.value.status);
          if (this.paymentBasics.includes(e.label)) {
            dataCompare.push(_.escape(e.value.description));
          } else if (e.label == "Stripe") {
            e.value.data.map(val => {
              dataCompare.push(val.status);
              val.value.map(inner => {
                dataCompare.push(inner.value);
              });
            });
          } else if (e.label == "Paypal") {
            e.value.data.map(val => {
              dataCompare.push(val.status);
              dataCompare.push(val.value);
            });
          }
        });
        if (_.isEqual(dataCompare, this.checkPaymentOption)) {
          this.disabledSaved = true;
          if (this.paymentOptionInitial.data.length === 0) {
            this.paymentOptionInitial.status = true;
            this.disabledSaved = false;
          }
        } else {
          this.disabledSaved = false;
          if (this.paymentOptionInitial.data.length === 0) {
            this.paymentOptionInitial.status = false;
          }
        }
        if (!firstLevelStatus.includes(true)) {
          this.disabledSaved = true;
        }
      },
      deep: true
    }
  },
  async created() {
    this.selectedSetting = this.settings[0];
    this.hoveredWidget.push(this.settings[0].id);

    this.SET_SETTINGS_LOADER(true);
    await this.$store.dispatch("fetchOptions");
    this.SET_SETTINGS_LOADER(false);

    let arraykey = [
      "sociallogin.main",
      "sociallogin.sub",
      "defaultlogo.main",
      "defaultlogo.sub",
      "support.welcome",
      "support.feedback",
      "support.main",
      "support.sub",
      "concierge.main",
      "concierge.sub",
      "concierge.sms",
      "concierge.leads",
      "concierge.logs",
      "payment.main",
      "paymentoption.main",
      "invoice.main",
      "paypal.main"
    ];

    let assignKey = {
      socialMain: {},
      socialSub: {},
      logoMain: {},
      logoSub: {},
      welcomeMain: {},
      feedbackMain: {},
      supportMain: {},
      supportSub: {},
      conciergeMain: {},
      conciergeSub: {},
      smsMain: {},
      leadsMain: {},
      logsMain: {},
      paymentMain: {},
      paymentOptionMain: {},
      invoiceMain: {},
      paypalMain: {},
      alertForPayment: false
    };
    let i = 0;
    for (let key in assignKey) {
      assignKey[key] = _.filter(this.options, ["key", arraykey[i]]);
      i++;
    }
    if (assignKey.paymentOptionMain.length === 0) {
      this.disabledSaved = true;
      this.paymentOptionInitial.status = true;
      this.paymentOptionInitial.data = assignKey.paymentOptionMain;
    }
    this.SET_PAYMENT_METHOD(
      JSON.parse(JSON.stringify(this.isPaymentOptionMain))
    );

    const paymentOptionsMap = new Map(
      this.isPaymentOptionMain.map(item => [item.label, item])
    );

    if (assignKey.paymentOptionMain.length) {
      assignKey.paymentOptionMain.forEach(item => {
        paymentOptionsMap.set(item.label, item);
      });
    }

    const isPaymentOptionMain = Array.from(
      paymentOptionsMap,
      ([, value]) => value
    );

    this.isSocialMain = assignKey.socialMain.length
      ? assignKey.socialMain
      : this.isSocialMain;
    this.isSocialGroup = assignKey.socialSub.length
      ? assignKey.socialSub
      : this.isSocialGroup;
    this.isDefaultLogo = assignKey.logoMain.length
      ? assignKey.logoMain
      : this.isDefaultLogo;
    this.isDefaultLogoSub = assignKey.logoSub.length
      ? assignKey.logoSub
      : this.isDefaultLogoSub;
    this.isSupportMain = assignKey.supportMain.length
      ? assignKey.supportMain
      : this.isSupportMain;
    this.isSupportGroup = assignKey.supportSub.length
      ? assignKey.supportSub
      : this.isSupportGroup;
    this.isWelcomeMain = assignKey.welcomeMain.length
      ? assignKey.welcomeMain
      : this.isWelcomeMain;
    this.isFeedbackMain = assignKey.feedbackMain.length
      ? assignKey.feedbackMain
      : this.isFeedbackMain;
    this.isCompaniesMain = assignKey.conciergeMain.length
      ? assignKey.conciergeMain
      : this.isCompaniesMain;
    this.isCompaniesGroup = assignKey.conciergeSub.length
      ? assignKey.conciergeSub
      : this.isCompaniesGroup;
    this.isSmsMain = assignKey.smsMain.length
      ? assignKey.smsMain
      : this.isSmsMain;
    this.isLeadsMain = assignKey.leadsMain.length
      ? assignKey.leadsMain
      : this.isLeadsMain;
    this.isLogsMain = assignKey.logsMain.length
      ? assignKey.logsMain
      : this.isLogsMain;
    this.isPaymentMain = assignKey.paymentMain.length
      ? assignKey.paymentMain
      : this.isPaymentMain;
    this.isPaymentOptionMain = isPaymentOptionMain;
    this.isPaypalMain = assignKey.paypalMain.length
      ? assignKey.paypalMain
      : this.isPaypalMain;

    this.getChanges();

    let invIndex = _.findIndex(this.settings, val => {
      return val.label == "Invoice Details";
    });
    this.settings[invIndex].data = assignKey.invoiceMain.length
      ? assignKey.invoiceMain
      : this.settings[invIndex].data;

    this.SET_SETTINGS_LOADER(true);
    await this.$store.dispatch("fetchEmailNotification");
    this.SET_SETTINGS_LOADER(false);
    this.defaultLogoStatus = this.isDefaultLogo[0].value.status;
  },
  computed: {
    ...mapGetters([
      "currentScheme",
      "getUser",
      "GET_SETTINGS_LOADER",
      "GET_PAYMENT_METHOD"
    ]),
    ...mapState(["scheme"]),
    savedScheme() {
      return this.$store.state.concierge.schemeList;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    options() {
      return this.$store.state.concierge.optionsList.data;
    },
    emailNotif() {
      return this.$store.state.concierge.emailNotificationsLists.data;
    }
  },
  methods: {
    ...mapActions([
      "updateScheme",
      "updateLogo",
      "SET_SETTINGS_LOADER",
      "SET_PAYMENT_METHOD"
    ]),
    handleChooseTheme(params) {
      this.selectedScheme = params;
    },
    async handleSaveSubmit(slug) {
      let requestData = {};
      let requestInfo = {
        type: null,
        form: {}
      };

      switch (slug) {
        case "user-registration-setting":
          var socialForm = [];
          for (let pair of this.isSocialGroup) {
            socialForm.push(pair);
          }
          for (let pair of this.isSocialMain) {
            socialForm.push(pair);
          }
          requestInfo.type = "sociallogin";
          requestInfo.form = socialForm;
          break;
        case "logo-setting":
          var logoForm = [];
          for (let pair of this.isDefaultLogoSub) {
            logoForm.push(JSON.parse(JSON.stringify(pair)));
          }
          for (let pair of this.isDefaultLogo) {
            logoForm.push(JSON.parse(JSON.stringify(pair)));
          }
          logoForm[1].value.status = this.defaultLogoStatus;
          var logoSetup = this.defaultLogoStatus
            ? null
            : logoForm[0].value.image;
          this.selectedLogo = {
            status: this.defaultLogoStatus,
            image: logoSetup
          };
          this.updateLogo(this.selectedLogo);
          requestInfo.type = "defaultlogo";
          requestInfo.form = logoForm;
          break;
        case "user-dashboard-setting":
          var supporForm = [];
          for (let pair of this.isSupportGroup) {
            supporForm.push(pair);
          }
          for (let pair of this.isSupportMain) {
            supporForm.push(pair);
          }
          for (let pair of this.isWelcomeMain) {
            supporForm.push(pair);
          }
          for (let pair of this.isFeedbackMain) {
            supporForm.push(pair);
          }
          requestInfo.type = "support";
          requestInfo.form = supporForm;
          break;
        case "concierge-dashboard-setting":
          var concierge = [];
          for (let pair of this.isCompaniesMain) {
            concierge.push(pair);
          }
          for (let pair of this.isCompaniesGroup) {
            concierge.push(pair);
          }
          for (let pair of this.isSmsMain) {
            concierge.push(pair);
          }
          for (let pair of this.isLeadsMain) {
            concierge.push(pair);
          }
          for (let pair of this.isLogsMain) {
            concierge.push(pair);
          }
          requestInfo.type = "concierge";
          requestInfo.form = concierge;
          break;
        case "payment-method-setting":
          var payment = [];
          for (let pair of this.isPaymentMain) {
            payment.push(pair);
          }
          requestInfo.type = "payment";
          requestInfo.form = payment;
          break;
        case "payment-options-setting":
          var paymentOption = [];
          for (let pair of this.isPaymentOptionMain) {
            paymentOption.push(pair);
          }
          requestInfo.type = "paymentOption";
          requestInfo.form = paymentOption;
          this.alertForPayment = true;
          this.checkPaymentOption = [];
          this.getChanges();
          this.disabledSaved = true;
          break;
        case "invoice-details-setting":
          requestInfo.type = "invoice";
          requestInfo.form = this.selectedSetting.data;
          break;
        case "paypal-api-setting":
          var paypal = [];
          for (let pair of this.isPaypalMain) {
            paypal.push(pair);
          }
          requestInfo.type = "paypal";
          requestInfo.form = paypal;
          break;
        case "color-setting":
          await this.updateScheme(this.selectedScheme);
          var form = {
            userId: this.getUser.id,
            key: this.selectedScheme.id,
            value: JSON.stringify(this.selectedScheme)
          };
          await this.handleSubmitScheme(form);
          this.$socket.emit("tenant:SetScheme", this.selectedScheme);
          await this.$swal({
            type: "success",
            text: "Theme changed!"
          });
          break;
      }
      requestData = {
        type: requestInfo.type,
        form: JSON.parse(JSON.stringify(requestInfo.form))
      };
      if (slug != "color-setting") {
        this.SET_SETTINGS_LOADER(true);
        let result = await this.$store.dispatch("postOption", requestData);
        this.SET_SETTINGS_LOADER(false);
        if (this.alertForPayment) {
          await this.$swal({
            type: "success",
            text: "Changes saved successfully"
          });
        } else {
          this.toastrInit(result);
        }
      }
      if (slug == "logo-setting") {
        this.SET_SETTINGS_LOADER(true);
        await this.$store.dispatch("fetchOptions", "defaultlogo");
        this.SET_SETTINGS_LOADER(false);
      }
    },
    async handleSubmitScheme(form) {
      this.SET_SETTINGS_LOADER(true);
      await this.$store.dispatch("postScheme", form);
      this.SET_SETTINGS_LOADER(false);
    },
    handleSettingClick(setting) {
      this.lastSettingClick = setting;
      if (
        this.selectedSetting.id == 7 &&
        !this.disabledSaved &&
        !this.paymentOptionInitial.status
      ) {
        this.showAwayMessage = true;
      } else {
        this.selectedSetting = setting;
        this.hoveredWidget = [];
        this.hoveredWidget.push(setting.id);
      }
    },
    handleAddClick(id) {
      switch (id) {
        case 0:
          this.$emit("showModal", {
            name: "add-email",
            hasBackdropEvent: false
          });
          break;
        case 1:
          this.$emit("showModal", {
            name: "add-whitelisted-domain",
            hasBackdropEvent: false
          });
          break;
        case 2:
          this.$emit("showModal", {
            name: "add-whitelisted-manager",
            hasBackdropEvent: false
          });
          break;
      }
    },
    handleEditClick(params) {
      this.$emit("showModal", {
        name: "edit-settings",
        user: params,
        hasBackdropEvent: false
      });
    },
    handleDeleteNotif(params) {
      let notifId = params.id;
      this.$swal
        .fire({
          title: "Are you sure you want to deactivate this notification?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes"
        })
        .then(async result => {
          if (result.value) {
            this.SET_SETTINGS_LOADER(true);
            await this.$store.dispatch("deleteEmailNotification", notifId);
            this.activeIndex = this.activeIndex == 0 ? 0 : this.activeIndex - 1;

            this.$toastr.success("Your changes are saved.", "Saved");

            await this.$store.dispatch("fetchEmailNotification");
            this.SET_SETTINGS_LOADER(false);
          }
        });
    },
    handleFileUpload(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.fileName = file.name;
    },
    handleResponse(obj) {
      this.media = obj;
      // update eventform.featuredimage state here
      // user media.original for now

      this.isDefaultLogoSub[0].value.image = this.media.original;
    },
    handleCloseMedia() {
      this.showModalGallery = false;
    },
    handlePaypalToggle() {
      this.isPaypalMain[1].value.status = !this.isPaypalMain[1].value.status;
      this.isPaypalMain[0].value.status = !this.isPaypalMain[0].value.status;
    },
    getChanges() {
      this.isPaymentOptionMain.map(e => {
        this.checkPaymentOption.push(e.value.status);
        if (this.paymentBasics.includes(e.label)) {
          this.checkPaymentOption.push(_.escape(e.value.description));
        } else if (e.label == "Stripe") {
          e.value.data.map(val => {
            this.checkPaymentOption.push(val.status);
            val.value.map(inner => {
              this.checkPaymentOption.push(inner.value);
            });
          });
        } else if (e.label == "Paypal") {
          e.value.data.map(val => {
            this.checkPaymentOption.push(val.status);
            this.checkPaymentOption.push(val.value);
          });
        }
      });
    },
    handleClose() {
      this.showAwayMessage = false;
    },
    async handleProceedSelect() {
      let setting = this.lastSettingClick;
      this.selectedSetting = setting;
      this.hoveredWidget = [];
      this.hoveredWidget.push(setting.id);
      this.showAwayMessage = false;

      await this.$store.dispatch("fetchOptions", "paymentoption");
      if (this.options.length) {
        this.isPaymentOptionMain = this.options;
        this.disabledSaved = false;
      } else {
        this.isPaymentOptionMain = this.GET_PAYMENT_METHOD;
      }
    },
    labelTrimmer(str) {
      return str.replace("ID", "");
    }
  }
};
</script>

<style lang="scss" scoped>
.advanced-settings {
  height: calc(100vh - 183px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 15px;
}
.content--main {
  padding-bottom: 20px;
  padding-top: 20px;
}
.settings {
  &-wrapper {
    background-color: $gray-50;
    border-radius: 5px;
  }
  &-table--wrapper {
    background-color: $gray-50;
    padding: 0 30px 30px;
    .table-controls {
      h4 {
        font-size: 14px;
      }
    }
  }
}
.setting {
  background-color: $gray-50;
  border-bottom: 1px solid $gray-250;
  cursor: pointer;
  padding: 25px 20px;
  transition: background-color 0.2s ease;
  &.active,
  &:hover {
    background-color: $brand-secondary;
  }
  p {
    color: $gray-900;
    font-family: "Gotham";
    font-weight: 500;
    font-size: $font-size-xs;
    margin-bottom: 0;
  }
  &:last-child {
    border-bottom: 0;
  }
}
.table {
  &-controls {
    align-items: center;
    border-bottom: 1px solid $gray-250;
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    padding: 30px 0 15px;
    h4 {
      color: $gray-900;
      font-family: "Gotham";
      font-weight: 500;
      font-size: $font-size-xs;
      margin-bottom: 0;
    }
  }
  &__actions-wrapper {
    align-items: center;
    display: flex;
    position: relative;
  }
  &__nav {
    button {
      background-color: $brand-secondary;
      border-radius: 5px;
      border: none;
      cursor: pointer;
      display: block;
      height: 32px;
      margin-right: 10px;
      width: 32px;
    }
    span {
      color: $gray-900;
      font-family: "Gotham";
      font-weight: 500;
      font-size: $font-size-xs;
      margin-bottom: 20px;
    }
  }
  button {
    border: none;
    height: 23px;
    padding: 0;
    transition: all 0.3s ease;
    width: 23px;
    &:hover {
      background-color: $gray-250;
    }
    &.btn {
      &-danger {
        background-color: #ef5350 !important;
        &:hover {
          background-color: #c82333 !important;
        }
      }
    }
  }
}
.sub-group {
  margin-left: 40px;
}
.form-group {
  input {
    display: block;
  }
  label {
    font-size: 12px;
  }
}
.bordered-top {
  border-top: 1px solid $gray-200;
}
.scheme-wrapper {
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
  &:hover,
  &.selected {
    .circle {
      &.-outer {
        border-color: $gray-700;
      }
      &.-inner {
        transform: scale(1);
      }
    }
  }
}
.circle {
  border: 3px solid transparent;
  border-radius: 50%;
  height: 50px;
  margin: auto;
  transition: all 0.2s linear;
  width: 50px;
  &.-outer {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  &.-inner {
    height: 30px;
    transform: scale(0.8);
    transition: transform 0.2s linear;
    width: 30px;
  }
}
.payment-options {
  font-size: 12px;
  .method-holder {
    padding-top: 10px;
    .quillWrapper {
      margin-top: 10px;
    }
    .portal-holder {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        margin-bottom: 15px;
      }
    }
    .form-group {
      margin-left: 15px;
      label {
        font-weight: 400;
        font-family: "Rubik", sans-serif;
      }
    }
  }
}
.text-upper {
  text-transform: uppercase;
}
</style>
